import { InlineInput } from "@/components/ui/inline-input"
import { Label } from "@/components/ui/label"
import { Card, CardContent, CardDescription, CardHeader, CardTitle, } from "@/components/ui/card"
import { t } from "@/lib/i18n"
import { patchInline } from "@/lib/inline-update"
interface ProfileFormProps {
    defaultValues: {
        name: string
        email: string
    }
}
export function ProfileForm({ defaultValues }: ProfileFormProps) {
    return (<Card variant="borderless">
      <CardHeader>
        <CardTitle>{t("ui.react.components.features.profiles.profile_form.information_staff")}</CardTitle>
        <CardDescription>{t("ui.react.components.features.profiles.profile_form.update_name_email")}</CardDescription>
      </CardHeader>
      <CardContent>
        <div className="space-y-6" data-testid="profile-edit-form">
          <div className="space-y-2">
            <Label htmlFor="name">{t("ui.react.components.features.profiles.profile_form.name")}</Label>
            <InlineInput id="name" data-testid="profile-name-input" value={defaultValues.name} onSubmit={(value) => patchInline("/profile", { name: value })}/>
          </div>
          <div className="space-y-2">
            <Label htmlFor="email_address">{t("ui.react.components.features.profiles.profile_form.email")}</Label>
            <InlineInput id="email_address" data-testid="profile-email-input" type="email" value={defaultValues.email} onSubmit={(value) => patchInline("/profile", { email_address: value })}/>
          </div>
        </div>
      </CardContent>
    </Card>)
}
